/**
 * Article Repository Hook
 *
 * Provides access to the article repository from the context.
 */

import { useRepositoryContext } from '../repositories';
import type { IArticleRepository } from '../repositories/interfaces/IArticleRepository';

/**
 * Hook to access the article repository
 * Must be used within a RepositoryProvider
 */
export function useArticleRepository(): IArticleRepository {
  const { articles } = useRepositoryContext();
  return articles;
}
